import { rupiah } from "@/lib/format";

export function normalizePhone(phone) {
  if (!phone) return null;
  let p = String(phone).replace(/\D/g, "");
  if (p.startsWith("0")) p = "62" + p.slice(1);
  else if (p.startsWith("8")) p = "62" + p;
  return p.length >= 9 ? p : null;
}

export function waLink(phone, message) {
  const p = normalizePhone(phone);
  if (!p) return null;
  return `https://wa.me/${p}?text=${encodeURIComponent(message)}`;
}

export const waMessages = {
  reminder: ({ parentName, studentName, className, grade, monthName, year, amount }) =>
    `Yth. Bapak/Ibu ${parentName || "Orang Tua/Wali"},\n\n` +
    `Kami dari Gihon Cantata Sekolah Musik ingin mengingatkan pembayaran SPP bulan ${monthName} ${year} untuk siswa:\n\n` +
    `Nama: ${studentName}\nKelas: ${className}\nGrade: ${grade}\nJumlah: ${rupiah(amount)}\n\n` +
    `Mohon melakukan pembayaran secepatnya. Terima kasih.\n\n— Gihon Cantata Sekolah Musik`,
  confirmation: ({ parentName, studentName, monthName, year, amount, receiptNo, method }) =>
    `Yth. Bapak/Ibu ${parentName || "Orang Tua/Wali"},\n\n` +
    `Pembayaran SPP telah kami terima dengan rincian:\n\n` +
    `No. Kwitansi: ${receiptNo}\nNama Siswa: ${studentName}\nPeriode: ${monthName} ${year}\n` +
    `Jumlah: ${rupiah(amount)}\nMetode: ${method}\n\n` +
    `Terima kasih atas pembayarannya.\n\n— Gihon Cantata Sekolah Musik`,
  general: ({ parentName, studentName }) =>
    `Yth. Bapak/Ibu ${parentName || "Orang Tua/Wali"}${studentName ? ` (ortu/wali ${studentName})` : ""},\n\n` +
    `Kami dari Gihon Cantata Sekolah Musik. Ada yang bisa kami bantu?\n\n— Gihon Cantata Sekolah Musik`,
  subscription: ({ adminName, schoolName, plan, dueDate, productName }) =>
    `Yth. Bapak/Ibu ${adminName || "Admin"}${schoolName ? ` (${schoolName})` : ""},\n\n` +
    `Kami dari tim ${productName || "Cantata"}. ` +
    (dueDate
      ? `Langganan${plan ? ` paket ${plan}` : ""} untuk sekolah Anda jatuh tempo pada ${dueDate}.\n\n`
      : `Langganan untuk sekolah Anda telah berakhir.\n\n`) +
    `Mohon segera melakukan pembayaran agar layanan sekolah Anda tetap aktif. Terima kasih.\n\n— Tim ${productName || "Cantata"}`,
  teacher: ({ name }) =>
    `Yth. Bapak/Ibu ${name || "Guru"},\n\n` +
    `Kami dari Gihon Cantata Sekolah Musik. Ada yang bisa kami bantu terkait jadwal mengajar atau administrasi?\n\n— Gihon Cantata Sekolah Musik`,
};
